import { get, isNull } from "lodash"

export const getIsActive = state => !isNull(get(state, "modules.securityProfile.base"))
